import React from "react"
import Link from "../AntiLink"
import { Icon } from "react-icons-kit"
import { twitter } from "react-icons-kit/fa/twitter"
import { facebook } from "react-icons-kit/fa/facebook"
import { instagram } from "react-icons-kit/fa/instagram"
import { times } from "react-icons-kit/fa/times"
import { whatsapp } from "react-icons-kit/fa/whatsapp"
import { bars } from "react-icons-kit/fa/bars"
import RcDrawer from "rc-drawer"
import logo from "../../images/logo.png"
import navigations from "../../../content/data/navigations.yml"
import "rc-drawer/assets/index.css"
import { Flex, Button, Box } from "theme-ui"
import { BsTwitterX } from "react-icons/bs"

const Sidebar = ({ toggleSidebar, visible, lang }) => {
  const isArabic = lang === "ar"
  const urlPrefix = isArabic ? "/ar" : ""
  const SwitchLanguageLink = isArabic ? "/" : "/ar/"
  const SwitchLanguageHint = isArabic ? "English" : "عربي"

  return (
    <RcDrawer
      placement={isArabic ? "right" : "left"}
      handler={
        <Button
          aria-label="Toggle nav menu"
          aria-hidden={undefined}
          aria-pressed="mixed"
          className="btn-menu"
          onClick={toggleSidebar}
          sx={{
            visibility: ["visible", null, null, "hidden"],
            position: "absolute",
            top: 50,
            marginInlineEnd: -50,
          }}
        >
          <Icon icon={visible ? times : bars} />
        </Button>
      }
      onClose={toggleSidebar}
      open={visible}
    >
      <Flex
        sx={{
          px: 2,
          py: 3,
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
          height: "100vh",
        }}
      >
        <nav>
          <Box as="ul" sx={{ p: 0, listStyle: "none" }}>
            {navigations.map(item => (
              <Box as="li" sx={{ paddingY: [20, null, 0] }} key={item.uri}>
                <Link to={urlPrefix + item.uri} className="b-menu__item">
                  {item.titleobj[lang]}
                </Link>
              </Box>
            ))}
          </Box>
        </nav>
        <div>
          <img className="w-75" src={logo} alt="Benchmark" />
          <Flex
            sx={{
              a: {
                padding: 10,
              },
            }}
          >
            <a
              className="b-socials"
              href="https://www.facebook.com/benchmarkae/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon={facebook} className="fa fa-facebook fa-fw" />
            </a>
            <a
              className="b-socials"
              href="https://twitter.com/Benchmarkae"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BsTwitterX />
            </a>
            <a
              className="b-socials"
              href="https://www.instagram.com/bmdsae/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon={instagram} className="fa fa-instagram fa-fw" />
            </a>
            <a
              className="b-socials"
              href="https://wa.me/971554111919"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon={whatsapp} />
            </a>
          </Flex>
          <div>
            <Link
              to={SwitchLanguageLink}
              className="b-socials pointer text-white"
            >
              {SwitchLanguageHint}
            </Link>
          </div>
        </div>
      </Flex>
    </RcDrawer>
  )
}

export default Sidebar
